<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-monitor-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.604 36.36c1.087 0 1.969.88 1.969 1.968v1.896a1.969 1.969 0 01-1.969 1.969H8.396a1.969 1.969 0 01-1.969-1.969v-1.896a1.97 1.97 0 011.969-1.969h31.208zm-.656-30.553a2.625 2.625 0 012.625 2.625v22.619a2.625 2.625 0 01-2.625 2.625H9.052a2.625 2.625 0 01-2.625-2.625V8.432a2.625 2.625 0 012.625-2.625h29.896zM16.329 16.526c-.754 0-1.38.55-1.497 1.27l-.02.247v6.3a1.517 1.517 0 003.014.246l.02-.246v-6.3c0-.838-.68-1.517-1.517-1.517zm15.633 0c-.753 0-1.379.55-1.496 1.27l-.02.247v6.3a1.517 1.517 0 003.013.246l.02-.246v-6.3c0-.838-.679-1.517-1.517-1.517zm-7.816-4.667c-.754 0-1.38.55-1.497 1.271l-.02.246v10.967a1.517 1.517 0 003.014.246l.02-.246V13.376c0-.838-.68-1.517-1.517-1.517z"/></svg>
</template>
<script>

export default {
  name: 'IconMonitorFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
